import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NotFoundPageRoutingModule } from './not-found-routing.module';
import { NotFoundPageComponent } from './not-found.page.component';
import { MatColComponent } from 'libs/portal/src/modules/tools/mat-col/mat-col.component';
import { MatRowComponent } from 'libs/portal/src/modules/tools/mat-row/mat-row.component';

@NgModule({
  imports: [CommonModule, FormsModule, NotFoundPageRoutingModule, MatColComponent, MatRowComponent],
  declarations: [NotFoundPageComponent],
})
export class NotFoundPageModule {}
